import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

const WorkInProgress = () => {
  React.useEffect(() => {
    setTimeout(() => {
      reactLocalStorage.remove('entryAccessories');
      reactLocalStorage.remove('wardrobesConfigs');
      reactLocalStorage.remove('wardrobeHeight');
      reactLocalStorage.remove('activeWardrobe');
      reactLocalStorage.remove('token');
    }, 100);
  }, []);

  const message = window.wipMessage || 'Przepraszamy trwa aktualizacja...';

  return (
    <div className="work-in-progress-page">
      <img
        src={`${process.env.PUBLIC_URL}/img/start-screen-title.png`}
        className="wip-logo"
        alt="Konfigurator szaf flex"
      />
      <h1 className="wip-title">{message}</h1>
      <Link to={'/'} className="wip-button" replace>
        Odśwież <i className="icon-small-arrow"></i>
      </Link>
    </div>
  );
};

export default WorkInProgress;
